import React, { useState, useEffect } from 'react';
import ConferenceRegistration from "./components/ConferenceRegistration";
import Login from "./components/Login";

export default function App() {
  const [currentView, setCurrentView] = useState('login'); // 'login', 'registration', or 'success'
  const [existingUser, setExistingUser] = useState(null);
  const [prefilledEmail, setPrefilledEmail] = useState('');

  const handleLoginSuccess = (userData) => {
    console.log('Login successful for user:', userData);
    setExistingUser(userData);
    setCurrentView('registration');
  };

  const handleRegisterRedirect = (email = '') => {
    console.log('Redirecting to registration for email:', email);
    setPrefilledEmail(email);
    setExistingUser(null);
    setCurrentView('registration');
  };

  const handleBackToLogin = () => {
    setCurrentView('login');
    setExistingUser(null);
    setPrefilledEmail('');
  };

  // Payment Success View
  if (currentView === 'success') {
    // Show alerts and redirect to login
    useEffect(() => {
      alert("Payment successful! Processing registration...");
      setTimeout(() => {
        alert("Registered successfully. Details Emailed");
        // Clear URL and redirect to login
        window.history.replaceState({}, document.title, '/');
        setCurrentView('login');
        setExistingUser(null);
        setPrefilledEmail('');
      }, 500);
    }, []);

    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        flexDirection: 'column',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div style={{
          padding: '40px',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          textAlign: 'center',
          backgroundColor: 'white'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>✅</div>
          <h2 style={{ color: '#28a745', marginBottom: '10px' }}>Payment Successful!</h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>
            Processing your registration...
          </p>
          <div style={{
            border: '3px solid #28a745',
            borderRadius: '50%',
            borderTop: '3px solid transparent',
            width: '40px',
            height: '40px',
            margin: '0 auto',
            animation: 'spin 1s linear infinite'
          }}></div>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  if (currentView === 'login') {
    return (
      <Login 
        onLoginSuccess={handleLoginSuccess}
        onRegisterRedirect={handleRegisterRedirect}
      />
    );
  }

  return (
    <ConferenceRegistration 
      existingUser={existingUser}
      prefilledEmail={prefilledEmail}
      onBackToLogin={handleBackToLogin}
    />
  );
}